module.exports = __webpack_public_path__ + "static/media/client-logo-21.77dd5fd5.jpg";